import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SkeletonComponent } from '../skeleton/skeleton.component';

@Component({
  selector: 'csl-service-details-skeleton',
  standalone: true,
  imports: [SkeletonComponent],
  templateUrl: './service-details-skeleton.component.html',
  styleUrl: './service-details-skeleton.component.css',
  host: {
    class: 'flex flex-col',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceDetailsSkeletonComponent {}
